export default __webpack_public_path__ + "static/media/arrow_bottom.a68640a8.svg";